import {Directive, ElementRef, HostListener, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Subscription} from 'rxjs';
import {DropdownDirectiveService} from './dropdown-directive.service';

@Directive({
    selector: '[libDropdownToggle]'
})
export class DropdownToggleDirective implements OnInit, OnDestroy {

    /**
     * This class is added when status is active
     */
    @Input() cssClassIfActive: string;

    /**
     * Allowing toggle to close the dropdown on click, if dropdown is opened.
     * Set to false to prevent closing dropdown on toogle click and close dropdown by another way
     */
    @Input() canClose = true;
    @Input() canOpen = true;

    private sub: Subscription;

    constructor(
        private service: DropdownDirectiveService,
        private renderer: Renderer2,
        private elementRef: ElementRef,
    ) {
    }

    @HostListener('click', ['$event'])
    public onClickHandler(event: MouseEvent) {
        if (event) {
            event.preventDefault();
        }

        if (this.service.active && !this.canClose) {
            return;
        }

        if (!this.service.active && !this.canOpen) {
            return;
        }

        this.service.toggleActive();
    }

    ngOnInit() {
        if (this.cssClassIfActive) {
            this.sub = this.service.activeStatusChange$.subscribe((active: boolean) => {
                if (active) {
                    this.renderer.addClass(this.elementRef.nativeElement, this.cssClassIfActive);
                } else {
                    this.renderer.removeClass(this.elementRef.nativeElement, this.cssClassIfActive);
                }
            });
        }
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
